import axiosInstance from "../utils/axios";

const apiPath = '/api/order';

const OrderApi = {
	get: function (orderNumber, email) {
		// Encode user input: an email with '+' (gmail aliases) or an order number
		// with spaces/'#' would otherwise corrupt the query string.
		return axiosInstance.get(
			`${apiPath}/find?orderNumber=${encodeURIComponent(orderNumber)}&email=${encodeURIComponent(email)}`
		);
	},
	getById: function (orderId) {
		return axiosInstance.get(`${apiPath}/findById?orderId=${encodeURIComponent(orderId)}`);
	}
}

export default OrderApi;
